"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var buttonWithArrowStyles_1 = require("./buttonWithArrowStyles");
var ButtonWithIcon_1 = require("./ButtonWithIcon");
var ButtonWithArrow = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.iconSize, iconSize = _b === void 0 ? 48 : _b, _c = _a.arrowSize, arrowSize = _c === void 0 ? 20 : _c, _d = _a.labelSize, labelSize = _d === void 0 ? 'small' : _d, iconClasses = _a.iconClasses, props = __rest(_a, ["children", "className", "iconSize", "arrowSize", "labelSize", "iconClasses"]);
    var styles = buttonWithArrowStyles_1.default(__assign(__assign({}, props), { arrowSize: arrowSize, labelSize: labelSize }));
    return (<ButtonWithIcon_1.default {...props} iconSize={iconSize} className={[className, styles.root].join(' ')} iconClasses={iconClasses ? [iconClasses, styles.arrow].join(' ') : styles.arrow} labelClasses={styles.label}>
      {children}
    </ButtonWithIcon_1.default>);
};
exports.default = ButtonWithArrow;
